import ValidationWrapper from './ValidationWrapper';

export default ValidationWrapper;